import * as actionTypes from "./ExpenseSettingsType";

const INITIAL_STATE = {
    taxList: [],
    locationList: [],
    seriesList: [],
    SACList: [],
    settingList: [],
};
const ExpeseSettingsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETEXPSETSELECTTAX:
            return {
                ...state,
                taxList: action.payload.list,
            };
        case actionTypes.SETEXPSETLOCLIST:
            return {
                ...state,
                locationList: action.payload.list,
            };
        case actionTypes.SETEXPSETSERIESLIST:
            return {
                ...state,
                seriesList: action.payload.list,
            };
        case actionTypes.SETEXPSETSACLIST:
            return {
                ...state,
                SACList: action.payload.list,
            };
        case actionTypes.SETEXPSETTINGGET:
            return {
                ...state,
                settingList: action.payload.data
            }
        default:
            return state;
    }
}

export default ExpeseSettingsReducer;